import type I_AppState from "./I_AppState"

const appState: I_AppState = {
	authenticated: false,
	loggingIn: false,
}

export default appState
